import React from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

export default function Selector({ group, handleGroupChange }) {
  const { user } = useAuthenticator((context) => [context.user]);
  let email = '';
  if (user) {
    email = user.attributes.email;
  }

  return (
    <div id="Selector-Container">
      <div id="Selector-Body"> Hello {email}, you are part of the group {group} </div>
      <h1>Select a User Group</h1>
      <div><h3>Please select the user group you want to be a part of.</h3></div>
      <div id="Selector-Buttons">
        <input type="radio" name="userRole" value="admin" onClick={() => { handleGroupChange("admin"); alert(`Your group has been changed to Admin`); }} />
        Admin
        <input type="radio" name="userRole" value="stakeholder" onClick={() => { handleGroupChange("stakeholder"); alert(`Your group has been changed to Stakeholder`); }} />
        Stakeholder
        <input type="radio" name="userRole" value="researcher" onClick={() => { handleGroupChange("researcher"); alert(`Your group has been changed to Researcher`); }} />
        Researcher
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
  )
}